import { useEffect } from 'react';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { useStepperActions, useStepperActiveIndex } from '../../provider';

export const useProtected = (loginStepIndex: number | undefined = 0, protectedSteps: number[]) => {
  const activeIndex = useStepperActiveIndex();
  const { onEdit, onNext } = useStepperActions();
  const { verificationCompleted, user } = useAuth0();

  useEffect(() => {
    if (!user && !verificationCompleted && protectedSteps.includes(activeIndex)) {
      onEdit(loginStepIndex);
    }
    if (user && verificationCompleted && activeIndex === loginStepIndex) {
      onNext();
    }
  }, [user, verificationCompleted, activeIndex]);
};
